import classNames from "classnames";
import {
  ForwardedRef,
  forwardRef,
  InputHTMLAttributes,
  ReactElement,
  useId,
} from "react";

type RadioProps = InputHTMLAttributes<HTMLInputElement> & {
  label: string | ReactElement;
  labelClassName?: string;
  disabled?: boolean;
  hasError?: boolean;
};

export const Radio = forwardRef(function Radio(
  { label, disabled, labelClassName = "", hasError, ...props }: RadioProps,
  ref: ForwardedRef<HTMLInputElement>
) {
  const randomId = useId();

  return (
    <>
      <input
        type="radio"
        id={randomId}
        className="sr-only peer"
        disabled={disabled}
        ref={ref}
        {...props}
      />
      <label
        htmlFor={randomId}
        className={classNames(
          "font-style-body-md grid grid-cols-[min-content_1fr] grid-rows-[1fr] gap-2 before:row-start-1 before:row-end-1 before:col-start-1 before:rounded-full before:w-5 before:h-5 before:border-1.5 before:mt-px after:rounded-full after:w-2.5 after:h-2.5 after:col-span-1 after:row-start-1 after:row-end-1 after:col-start-1 after:ml-[5px] after:mt-[6px] after:transition peer-checked:after:bg-gray-1 peer-focus-visible:before:bg-gray-8 w-full",
          {
            ["before:border-gray-1 before:bg-transparent hover:before:bg-gray-8 active:before:bg-gray-5"]:
              !hasError && !disabled,
            ["cursor-not-allowed before:border-gray-6 peer-checked:after:bg-gray-6"]:
              disabled,
            ["cursor-pointer peer-checked:hover:before:border-gray-2 peer-checked:hover:before:bg-transparent peer-checked:hover:after:bg-gray-2"]:
              !disabled,
            ["before:border-danger-2 before:bg-danger-3 hover:before:bg-danger-3 active:before:bg-danger-3"]:
              hasError,
          },
          labelClassName
        )}
      >
        <span className="self-center">{label}</span>
      </label>
    </>
  );
});
